import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { selectAccessToken, selectRefreshToken, setReloginUrl } from '@lib/auth/store';

import { AuthState } from '../models/auth-state';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const store = inject(Store<AuthState>);
  const authService = inject(AuthService);
  const router = inject(Router);

  const accessToken = store.selectSignal(selectAccessToken);
  const refreshToken = store.selectSignal(selectRefreshToken);
  const hasValidTokens = accessToken() && refreshToken() && !authService.isTokenExpired(accessToken());

  if (hasValidTokens) {
    return true;
  } else {
    store.dispatch(setReloginUrl({ reloginUrl: state.url }));

    router.navigate(['/login']);
    return false;
  }
};
